//This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 782 ? "shell-bootstrap" : chunkId) + ".style." + {"237":"27d4db1cd92701c58751","782":"5d3e9e13ef33338c11f8"}[chunkId] + ".css";
};;